module.exports = __webpack_public_path__ + "static/media/sms-coupon-promo-preview.png";